import { render, staticRenderFns } from "./OneLove.vue?vue&type=template&id=f6c9f248"
import script from "./OneLove.vue?vue&type=script&lang=js"
export * from "./OneLove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports